import { VcDecorator } from '../../credential';
import { Claims, Ctor } from '../../types';
import { UnknownVerifiableCredential } from '../verifiable/unknown';
import { DraftCredential } from './draft';
import { DraftCredentialWithClaims } from './with-claims';

export class UnknownDraftCredential<T extends Claims | unknown = unknown> extends DraftCredential {
    async issue(privateKeyId: string): Promise<UnknownVerifiableCredential<T>> {
        const { descriptor } = await super.issue(privateKeyId);

        return new UnknownVerifiableCredential(this.client, descriptor);
    }

    async canMap<K extends Claims>(
        claimsModel: Ctor<T extends Claims ? (K extends T ? K : never) : K>,
    ): Promise<boolean> {
        const draftResource = await this.client.drafts.draftRevision(this.descriptor.id, this.descriptor.revision);
        const vcDecorator = new VcDecorator(this.client, claimsModel);

        return vcDecorator.canMap(draftResource);
    }

    async map<K extends Claims>(
        claimsModel: Ctor<T extends Claims ? (K extends T ? K : never) : K>,
    ): Promise<DraftCredentialWithClaims<T extends Claims ? (K extends T ? K : never) : K>> {
        const draftResource = await this.client.drafts.draftRevision(this.descriptor.id, this.descriptor.revision);
        const vcDecorator = new VcDecorator(this.client, claimsModel);

        return vcDecorator.map(draftResource);
    }
}
